import { dateFormat, truncateUrl, userFullName } from "helpers/common";
import { store } from "store/store";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CommonSelect, CommonToolTip, NoRecordFoundV2 } from "components/Common/Common";
import { useState } from "react";
import downArrow from "Assets/images/downArrowPurple.png"
import downArrowNormal from 'Assets/images/downArrowBlack.png'
import upArrow from "Assets/images/upArrowPurple.png"
import { Col, Row } from "react-bootstrap";
import { DOCUMENTS_FILTER_OPTIONS } from "config/constants";

const ClientAttachments = ({ resources, limit, filter = {}, isPage = false }) => {

    const [sortField, setSortField] = useState("date");   // date | type | name
    const [sortOrder, setSortOrder] = useState("desc");   // asc | desc

    const attachments = resources
        ?.filter(x => x.type === "attachment")
        ?.filter(x =>
            filter.resource_type
                ? x.resource_type === filter.resource_type
                : true
        );

    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

    const handleViewPdf = async (name) => {

        try {
            const result = await getFileUrl(name);
            if (result?.error) return;

            const url = result?.data
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("desc"); // default order
        }
    };

    const sortedAttachments = attachments
        ? [...attachments].sort((a, b) => {
            let A = "", B = "";

            // DATE SORTING
            if (sortField === "date") {
                A = new Date(a?.createdAt || a?.updatedAt);
                B = new Date(b?.createdAt || b?.updatedAt);
            }

            // TYPE SORTING
            if (sortField === "type") {
                A = a?.resource_type?.toLowerCase() || "";
                B = b?.resource_type?.toLowerCase() || "";
            }

            // NAME SORTING
            if (sortField === "name") {
                A = a?.attachment_name?.toLowerCase() || "";
                B = b?.attachment_name?.toLowerCase() || "";
            }

            if (sortOrder === "asc") {
                return A > B ? 1 : -1;
            } else {
                return A < B ? 1 : -1;
            }
        })
        : [];

    //Get the bg color accrding  to type
    const bgColors = {
        consent: "#ECFFDB",
        document: "#DBF8FB",
        report: "#FFE9FA",
    };

    const getBgColor = (name) => bgColors[name?.toLowerCase()] || "transparent";


    return (
        <>
            {getFileFetching && <LoadingOverlay />}
            <div className="mt-2">
                <table className="w-100">
                    <thead>
                        <tr>
                            <th onClick={() => handleSort("type")} className="fw-medium" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                <div className={`${sortField == 'type' && "themePurple cursor-pointer"} d-flex gap-2 align-items-center`}>
                                    TYPE
                                    <img width={9} height={9} src={sortField === "type" ? (sortOrder === "asc" ? upArrow : downArrow) : downArrowNormal} />
                                </div>
                            </th>
                            <th onClick={() => handleSort("name")} className="fw-medium" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                <div className={`${sortField == 'name' && "themePurple cursor-pointer"} d-flex gap-2 align-items-center`}>
                                    NAME
                                    <img width={9} height={9} src={sortField === "name" ? (sortOrder === "asc" ? upArrow : downArrow) : downArrowNormal} />
                                </div>
                            </th>
                            <th onClick={() => handleSort("date")} className="fw-medium" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                <div className={`${sortField == 'date' && "themePurple cursor-pointer"} d-flex gap-2 align-items-center`}>
                                    DATE
                                    <img width={9} height={9} src={sortField === "date" ? (sortOrder === "asc" ? upArrow : downArrow) : downArrowNormal} />
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                           sortedAttachments?.length > 0 ? sortedAttachments?.map((item, index) => {
                                if (limit && index >= limit) return null;

                                return (
                                    <tr
                                        className="cursor-pointer"
                                        onClick={() => handleViewPdf(item?.attachment_key)}
                                        key={index}
                                    >
                                        <td
                                            className="text-capitalize"
                                            style={{

                                                padding: "15px 10px",
                                                borderRadius: 0,
                                                borderBottom: "1px solid #8F8F8F",
                                            }}
                                        >
                                            <span
                                                className="proxima-regular"
                                                style={{
                                                    background: getBgColor(item?.resource_type),
                                                    padding: "8px",
                                                    borderRadius: "10%",
                                                    width: "100%",
                                                    display: "block",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {item?.resource_type}
                                            </span>

                                        </td>

                                        <td
                                            style={{
                                                padding: "15px 10px",
                                                borderRadius: 0,
                                                borderBottom: "1px solid #8F8F8F",
                                            }}
                                        >
                                            <CommonToolTip
                                                component={
                                                    <h6
                                                        style={{
                                                            textOverflow: "ellipsis",
                                                            overflow: "hidden",
                                                            fontSize: "14px",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {truncateUrl(item?.attachment_name, 40)}
                                                    </h6>
                                                }
                                                text={decodeURIComponent(item?.attachment_name)}
                                            />
                                        </td>

                                        <td
                                            style={{
                                                padding: "15px 10px",
                                                borderRadius: 0,
                                                borderBottom: "1px solid #8F8F8F",
                                            }}
                                        >
                                            {dateFormat(item?.createdAt, "MMM DD, YYYY")}
                                        </td>
                                    </tr>
                                );
                            }) : <tr>
                                <td colSpan={3} className="text-center py-3">
                                    <NoRecordFoundV2 message="No Record Found"/>
                                </td>
                            </tr>
                        }

                    </tbody>
                </table>
            </div>

        </>
    );
};

export default ClientAttachments;


